<template>
  <div id="app" v-cloak>
    <Header></Header>
    <router-view />
    <Footer></Footer>
  </div>

 
</template>

<script>
import Header from '@/components/header'
import Footer from '@/components/footer'

export default {
  name: 'App',
  components:{
    Header,Footer
  },
  created(){
    document.body.removeChild(document.getElementById('Loading'))
  }
}

// window.addEventListener('load', function () {
//   APP.$router.replace('/') 
// })
</script>

<style>
[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue